<template>
  <ai-customer-iframe type="library" />
</template>

<script>
import AiCustomerIframe from './ai-customer-iframe.vue'

export default {
  name: 'ai-customer-material',
  components: { AiCustomerIframe },
}
</script>
